/** Flight subpackage messages — English */
export default {
  plane: {
    nav: {
      home: 'Flight home',
      list: 'Flight routes',
      return: 'Round trip',
      detail: 'Flight details',
      orderFill: 'Create order',
      change: 'Flight change',
      selectAddress: 'Select location',
      selectFrom: 'Select departure',
      selectTo: 'Select destination',
      passengerAdd: 'Add passenger / policyholder',
      guide: 'Flight guide',
      treaty: 'Dangerous goods policy',
      luggage: 'Baggage rules',
      lowPrice: 'Domestic low fares',
      week: 'Weekend getaway',
      area: 'Regional low fares',
      remindList: 'Price alerts',
      remindFlights: 'Flight list',
      remindAdd: 'Add alert',
      intlOrderDetail: 'Order details',
      intlList: 'Intl flight routes',
      intlDetail: 'Intl flight details',
      intlChangeList: 'Intl change flights',
      intlChangeDetail: 'Change details',
      intlChange: 'Apply change',
      intlRefund: 'Apply refund',
      intlRefundDetail: 'Refund details',
      intlProgress: 'Refund progress',
    },
    common: {
      confirm: 'Confirm',
      cancel: 'Cancel',
      clear: 'Clear',
      reset: 'Reset',
      search: 'Search',
      book: 'Book',
      addToCart: 'Add to cart',
      addingToCart: 'Adding...',
      next: 'Next',
      done: 'Done',
      more: 'More',
      detail: 'Details',
      expand: 'Expand',
      collapse: 'Collapse',
      filter: 'Filter',
      viewResults: 'View results',
      moreSort: 'More sort options',
      sortTitle: 'Sort by',
      loading: 'Loading…',
      noMore: 'No more results',
      checkPrice: 'Check price',
      fewLeft: 'Few left',
      stopover: 'Stopover',
      stopoverWithTime: 'Stopover: {time}',
      shareFlight: 'Codeshare with flight {code}',
      from: 'Departure',
      to: 'Arrival',
      depCity: 'Departure city',
      arrCity: 'Arrival city',
      depDate: 'Departure date',
      arrDate: 'Return date',
      daysCount: '{count} day(s)',
      oneWay: 'One-way',
      roundTrip: 'Round trip',
      multiTrip: 'Multi-city',
      outbound: 'Outbound',
      inbound: 'Inbound',
      returnTrip: 'Return',
      outboundShort: 'Out',
      returnShort: 'Back',
      adult: 'Adult',
      child: 'Child',
      infant: 'Infant',
      adultChildSuffix: '{name} ({type})',
      withMeals: 'Meals included',
      withoutMeals: 'No meals',
      punctualityRate: 'On-time rate {rate}',
      totalDuration: 'Total duration: {duration}',
      totalDurationShort: 'Duration {duration}',
      remainingTickets: '{count} left',
      priceFrom: 'From ¥{price}',
      priceSuffix: 'up',
      perPersonPrice: 'per person',
      totalPrice: 'total',
      payFrom: 'Pay from ¥{price}',
      discounted: 'Saved ¥{amount}',
      discountFold: '{percentOff}% off',
      discountFoldCompact: '{percentOff}% off',
      specialPrice: 'Special fare',
      standardPrice: 'Standard',
      standardPriceFull: 'Standard fare',
      economyQuote: 'Economy quote',
      economy: 'Economy',
      business: 'Business',
      businessFirst: 'Business / first',
      businessFirstCabin: 'Business / first class',
      upgradeComfort: 'Upgrade for comfort',
      seatAngle: 'Seat angle:',
      seatAngleValue: '120° recline',
      seatWidth: 'Seat width:',
      seatWidthValue: '19% wider than economy',
      directOnly: 'Direct flights only',
      allDayDepart: 'All day departures',
      localTimeNote: 'Select change date (local time)',
      pendingConfirm: 'Pending confirmation',
      refundChangeDetail: 'Refund & change details',
      refundChangeLuggage: 'Refund, change & baggage',
      refundFetchFailed: 'Failed to load refund & change rules. Please retry.',
      refundUnavailable: 'Refund & change rules unavailable',
      airlinePolicyOriginal: 'Airline policy (original)',
      currentPeriod: 'Current period',
      currentPrice: 'Current',
      refundTaxOnly: 'Refund airport/tax fees only',
      perPerson: '/person',
      historyRecord: 'History',
      city: 'City',
      hotBadge: 'Hot',
      airport: 'Airport',
      depAirport: 'Departure airport',
      arrAirport: 'Arrival airport',
      depAirportLabel: 'Departure: {name}',
      arrAirportLabel: 'Arrival: {name}',
      depTimeSlot: 'Departure time slot',
      airline: 'Airline',
      airportSection: 'Airports',
      noAirlineLimit: 'Any airline',
      searchAirline: 'Search airlines',
      noAirlineData: 'No airline data',
      selectAirline: 'Select airline',
      collect: 'Favorite',
      collected: 'Favorited',
      collectedFlights: 'Saved flights',
      swipeToUnfavorite: 'Swipe left to remove',
      unfavorite: 'Remove favorite',
      collectedCount: 'Saved ({count})',
      installmentFree: 'Interest-free installments',
      banksSupported: 'Supported by 40 banks',
      shareDesc: '0-interest installments · 0 fees · Trusted by 40+ banks',
      shareBooking: 'Booking {from}-{to} flights on Interest-free travel',
      gotIt: 'Got it',
      tip: 'Notice',
      all: 'All',
      confirmBtn: 'Confirm',
      edit: 'Edit',
      delete: 'Delete',
      goSee: 'View',
      goSelectHotel: 'Select hotel',
      submitOrder: 'Submit order',
      payNow: 'Pay now',
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
      addNew: 'Add',
      addPassenger: 'Add passenger',
      selectPassenger: 'Select passenger(s)',
      noThreshold: 'No minimum',
      couponDefault: 'Coupon',
      noCoupon: 'Do not use coupon',
      noCouponAvailable: 'No coupons available',
      couponLoading: 'Loading coupons…',
      couponCount: '{count} available',
      couponValidUntil: 'Valid until: {date}',
      couponUnusable: 'Not available for this order',
      bankPayOnly: 'Valid for {bank} payment only',
      bankPayOnlyDefault: 'Valid for selected bank only',
      paymentLimit: 'Payment restriction',
      noInsurance: 'No coverage',
      insuranceNotice: 'Insurance notice',
      noInvoice: 'No invoice',
      giveUpCoverage: 'Skip coverage?',
      protectTrip: 'Protect your trip',
      accidentInsurance: 'Flight accident insurance',
      delayInsurance: 'Flight delay insurance',
      addProtection: 'Add trip protection',
      insuranceTagline: 'Travel insured, family at ease',
      policyholder: 'Policyholder',
      viewEdit: 'View / edit',
      moreDiscount: 'More offers',
      moreDiscountTitle: 'More discounts',
      agreeRead: 'I have read and agree',
      agreeAccept: 'I have read and accept',
      personalInfoAuth: 'Personal data authorization',
      dangerousGoodsLink: '(Lithium batteries, power banks & dangerous goods)',
      ticketFast: 'Fast ticketing within ~80 minutes',
      domesticIdOnly: '(Domestic IDs only)',
      flightHeader: 'Flights {from} to {to} on {date}',
      flightHeaderColon: 'Flights {from} to {to} on {date}:',
      routeArrow: '{from} → {to}',
      routeDash: '{from}-{to}',
      weekLabel: '{day}',
      weekPrefix: 'Week',
      weekdayNames: 'Sun,Mon,Tue,Wed,Thu,Fri,Sat',
      monthWeekend: '{month} weekend',
      weekendTitle: '{month} weekend getaway',
      maxLeaveDays: 'Max {count} leave day(s)',
      playDays: '{min}-{max} day trip',
      askLeave: 'Time off',
      weekend: 'Weekend',
      askDays: 'Take {count} day(s) off',
      playDaysShort: '{count}-day trip',
      roundTotal: 'Round-trip total',
      weekN: 'Week {count}',
      updatedAt: 'Updated at {time}',
      moreStrategies: 'More getaway tips',
      priceLowToHigh: 'Price: low to high',
      dateEarlyToLate: 'Date: early to late',
      departSuffix: 'depart',
      goDepart: 'Depart {date} ({weekday})',
      carrierOffer: 'Airline exclusive offer',
      departFrom: 'From {city}',
      endOfList: 'End of list — try another city',
      endOfLuggage: 'End of baggage rules',
      tapCategoryHint: 'Tap a category above',
      lastChapter: 'Last section',
      travelReminder: 'Travel alert>',
      expandReminder: 'Expand alert',
      tableColTime: 'Time',
      tableColFee: 'Fee',
      allowCheckin: 'Allowed in checked baggage',
      allowCarry: 'Allowed in carry-on',
      forbidCheckin: 'Not allowed checked',
      forbidCarry: 'Not allowed carry-on',
      forbidHandCarry: 'Not allowed as carry-on',
      restrictCheckin: 'Restricted checked',
      restrictCarry: 'Restricted carry-on',
      commonItems: 'Common items',
      note: 'Note',
      remark: 'Remarks',
      exampleOnly: 'For reference only; follow airport/airline rules',
      domesticLuggageTitle: 'Domestic baggage rules',
      singleSelect: 'Single',
      multiSelect: 'Multi',
      airportSuffix: '(Airport)',
      selectDepartDate: 'Select departure date',
      selectRoundTripDate: 'Select round-trip dates',
      selectLegDate: 'Select leg {n} date',
      outboundLabel: 'Out:',
      returnLabel: 'Return:',
      calendarOutboundTag: 'Outbound',
      calendarReturnTag: 'Return',
      calendarBothTag: 'Out / return',
      calendarNotSelected: 'Not selected',
    },
    date: {
      today: 'Today',
      tomorrow: 'Tomorrow',
      dayAfter: 'Day after',
      weekdaySun: 'Sun',
      weekdayMon: 'Mon',
      weekdayTue: 'Tue',
      weekdayWed: 'Wed',
      weekdayThu: 'Thu',
      weekdayFri: 'Fri',
      weekdaySat: 'Sat',
      monthDay: '{month}/{day}',
      monthDayDash: '{month}-{day}',
      monthDayWeek: '{month}/{day} ({weekday})',
      yearMonthDay: '{year}-{month}-{day}',
      yearMonthDayWeek: '{year}-{month}-{day} {weekday}',
      dateRange: '{start} – {end}',
      dateRangeShort: '{start} – {end}',
      returnDate: 'Return date',
      departDate: 'Departure date',
      calendarOutbound: 'Outbound',
      calendarReturn: 'Return',
      calendarBoth: 'Out / return',
      calendarNotSelected: 'Not selected',
      calendarTripN: 'Select leg {n} date',
      calendarTip: 'Dates are local; adult fares shown; price may change at payment',
      selectDepartDate: 'Select departure date',
      selectRoundDate: 'Select round-trip dates',
      outboundLabel: 'Out:',
      returnLabel: 'Return:',
      nightBadge: 'Overnight',
      departOn: 'Depart {date}',
      departDateRange: '{start} – {end}',
    },
    sort: {
      lowPriceFirst: 'Lowest price',
      directFirst: 'Direct first',
      departEarlyLate: 'Depart early → late',
      departLateEarly: 'Depart late → early',
      arriveEarlyLate: 'Arrive early → late',
      arriveLateEarly: 'Arrive late → early',
      shortestDuration: 'Shortest duration',
      timeSort: 'Sort by time',
      priceSort: 'Sort by price',
      priceLowToHigh: 'Price low to high',
      priceHighToLow: 'Price high to low',
      timeEarlyToLate: 'Depart early to late',
      timeLateToEarly: 'Depart late to early',
    },
    filter: {
      title: 'Filters',
      depTimeSlot: 'Departure time slot',
      airline: 'Airline',
      airport: 'Airport',
      depAirport: 'Departure airport',
      arrAirport: 'Arrival airport',
    },
    list: {
      empty: 'No results',
      returnSearchEmpty: 'No matching return flights. Please try again later.',
      timeoutTitle: 'Search results expired',
      timeoutDesc: 'Session timed out. Refreshing fares — please search again.',
      noFlightsFound: 'No flights found',
      elderHeader: 'Flights {from} to {to} on {date}:',
      rtTotalPrice: 'Round-trip total',
      flightDetail: 'Flight details',
      selectOutboundFirst: 'Please select an outbound flight first',
      selectReturnFirst: 'Please select a return flight',
      priceDelta: '+¥{price}',
      includeShare: 'Codeshare',
      saveVsSeparate: 'Save ¥{amount} vs separate',
    },
    detail: {
      refundRulesTitle: 'Refund fee rules',
      changeRulesTitle: 'Change fee rules',
      transferRulesTitle: 'Transfer to other airlines',
      freeLuggageTitle: 'Free baggage allowance',
      adultChildBoth: 'Adult & child',
      adultBracket: '[Adult]',
      childBracket: '[Child]',
      outboundTab: 'Outbound policy',
      returnTab: 'Return policy',
      tabPriceFrom: 'From ¥{price}',
      outboundPolicy: 'Outbound',
      returnPolicy: 'Return',
      travelAlert: 'Trip alert:',
    },
    home: {
      tabDomestic: 'Flights',
      tabIntl: 'International',
      tabSpecial: 'Special fares',
      wayOneWay: 'One-way',
      wayRound: 'Round trip',
      searchFlights: 'Search flights',
      searchSpecial: 'Search deals',
      passengerSummary: '{adult} adult(s), {child} child(ren), {infant} infant(s)',
      withChild: 'With child',
      withInfant: 'With infant',
      childAgeHint: 'Ages 2–12',
      infantAgeHint: '14 days – 2 years',
      childInfantGuide: 'Child/infant booking info',
      childInfantGuideLink: 'Child/infant guide >',
      adultAgeRule: 'Age 12+',
      childAgeRule: 'Ages 2–12',
      infantAgeRule: '14 days – 2 years',
      intlChildRule1: '·Max 1 child/infant combined per adult',
      domesticChildRule1: '·Max 2 children and 1 infant per adult',
      pricePerPersonNote: '·Shows per-person price for {n} (excl. taxes)',
      priceTotalNote: '·Shows total for {n} (incl. taxes)',
      addLeg: 'Add another leg',
      addLegTip: '(Up to 5 legs)',
      airlineLabel: 'Airline',
      specialDepart: 'Depart: {range}',
      flightGuideTitle: 'Travel tips',
      flightGuideDesc: 'Complete flight guide',
      specialZone: 'Deals zone',
      weekendCheap: 'Cheap weekend getaways',
      monitoring: '24/7 monitoring',
      lowPriceDetected: 'Low fares found for {count} users today',
      watchRoutes: 'Watched routes',
      watchRoutesTip: '| Alert when price drops',
      monitoringStatus: 'Monitoring',
      priceRising: 'Prices may rise — book soon',
      ticketsTight: 'Few seats left',
      swipeEditDelete: '← Swipe to edit/delete',
      swipeDelete: '← Swipe to delete',
      addLowPriceAlert: 'Add price alert',
      addReminderBanner: 'Get notified when price drops',
      addReminder: 'Add alert',
      viewMore: 'View more',
      detectNearby: 'Also check nearby dates',
      followFavorite: 'Also watch favorite flights',
      favoriteDropAlert: 'Alert when fare drops',
      cabinEconomy: 'Economy',
      cabinBusinessFirst: 'Business / first',
      wayMulti: 'Multi-city',
      searchBtn: 'Search',
      flightGuideMore: 'More >',
      loadingAirlines: 'Loading…',
      elderDepCity: 'Departure city',
      elderArrCity: 'Arrival city',
      elderDepDate: 'Departure date',
      elderArrDate: 'Return date',
      inspirationFrom: 'Ideas from {city}',
      weekStrategyTitle: 'Best way to extend your holiday?',
      weekStrategy: 'Getaway tips',
      lowPriceAlertTitle: 'Notify me when price drops?',
      lowPriceAlert: 'Price alert',
      goSee: 'View',
      localGuide: 'Local travel guide',
      featuredRecommend: 'Featured',
      roundTripTotal: 'Round-trip total',
      weekN: 'Week {count}',
      updatedAt: 'Updated at {time}',
      askLeave: 'Time off',
      playDaysShort: '{count}-day trip',
      departFrom: 'From {city}',
      shareFlashTitle: 'Interest-free deals · limited-time fares',
      selectCity: 'Select city',
    },
    change: {
      stepApply: 'Change request',
      stepSelectFlight: 'Select flight',
      stepSelectCabin: 'Select cabin',
      selectPassengers: 'Select passengers to change',
      selectItinerary: 'Select itinerary',
      viewFlights: 'View flights',
      priceDetailTitle: 'Price breakdown',
      actualPay: 'Amount due',
      adultDiff: 'Adult fare difference',
      childDiff: 'Child fare difference',
      changeFeeAdult: 'Change fee',
      changeFeeChild: 'Child change fee',
      step01: '01',
      step02: '02',
      step03: '03',
      selectDateLocal: 'Select change date (local time)',
    },
    order: {
      priceDetail: 'Price details',
      priceLine: 'Ticket ¥{ticket} + taxes ¥{tax}',
      passengers: 'Passenger(s)',
      passengerInfo: 'Passenger information',
      contactReceiver: 'Order notification contact',
      contactPhone: 'Contact phone',
      contactPlaceholder: 'For booking notifications',
      contactPlaceholderShort: 'For order / schedule alerts',
      hotelBundleTitle: 'Add hotel',
      hotelBundleTitleLong: 'Add hotel — up to 12 interest-free installments',
      hotelBundleDesc: 'Flight + hotel bundle savings',
      hotelBundleDescLong: 'Book flight + hotel together',
      name: 'Name',
      namePlaceholder: 'As on travel document',
      idNumber: 'ID number',
      idNumberPlaceholder: 'Enter ID number',
      mobilePlaceholder: 'Enter mobile number',
      idCard: 'ID card',
      householdRegister: 'Household register',
      noChildSupport: 'Children not supported on this flight',
      amountDetail: 'Amount breakdown',
      priceDetails: 'Price breakdown',
      expandPassengers: 'Show all {count}',
      installmentPeriod: '{count} mo.',
      totalDiscount: 'Save ￥{amount}',
      ticketFee: 'Airfare',
      airportTax: 'Airport fee',
      fuelSurcharge: 'Fuel surcharge',
      productWithTax: '{product} (incl. taxes)',
      contactInfoTitle: 'Contact info notice',
      contactInfoBody: 'This contact will receive schedule change notices. We recommend using your own mobile number so you are notified promptly.',
      contactInfoNote: 'Note: includes schedule changes, cancellations, aircraft swaps, air traffic control, airport or weather delays, and flight consolidation.',
      selectIdType: 'Select ID type',
      otherOptions: 'Other options',
      allIdTypes: 'All ID types',
      infantIdTip: 'Infant IDs: ID card, passport, household register, birth certificate',
      childIdTip: 'Child IDs: ID card, passport, household register',
      taxFuelExplainTitle: 'Airport & fuel surcharge',
      taxFuelExplainIntro: 'Includes airport construction and fuel surcharges',
      taxFuelAirportTitle: '1. Airport construction fee',
      taxFuelAirportBody: 'Per CAAC and Ministry of Finance rules, passengers booking domestic, international, or HK/Macao/Taiwan flights from mainland China airports pay an airport construction fee shown separately from the ticket price.',
      taxFuelFuelTitle: '2. Fuel surcharge',
      taxFuelFuelAfterDate: 'From Oct 5, 2024 (ticket issue date) 00:00',
      taxFuelFuelAfterRule1: 'Domestic fuel surcharge: ¥10 per passenger for routes ≤800 km; ¥20 for routes >800 km.',
      taxFuelFuelAfterRule2: 'Infants at 10% of adult fare: no fuel surcharge.',
      taxFuelFuelAfterRule3: 'Children at 50% of adult fare, disabled military/police: no surcharge ≤800 km; ¥10 per passenger >800 km.',
      taxFuelFuelBeforeDate: 'Before Oct 5, 2024 (ticket issue date) 00:00',
      taxFuelFuelBeforeRule1: 'Domestic fuel surcharge: ¥30 per passenger for routes ≤800 km; ¥50 for routes >800 km.',
      taxFuelFuelBeforeRule2: 'Infants at 10% of adult fare: no fuel surcharge.',
      taxFuelFuelBeforeRule3: 'Children at 50% of adult fare, disabled military/police: ¥10 ≤800 km; ¥20 >800 km.',
      selectPolicyholder: 'Select policyholder',
      policyholderAgeTip: 'Policyholder must be 18+',
      addPolicyholder: 'Add policyholder',
      coverageContent: 'Coverage',
      insuranceDetail: 'Insurance details',
      invoice: 'Invoice',
      selectCoupon: 'Select coupon',
      policyholderExplain: 'The policyholder is the person who signs the insurance contract and pays premiums; must be over 18.',
      changeCouponWarn: 'Changing may forfeit interest-free installments. Continue?',
      keepChange: 'Keep current',
      confirmChange: 'Confirm change',
      noInvoiceInsurance: 'Invoice not available for this product',
      cancelCouponWarn: 'Canceling may forfeit installments. Continue?',
      keepCoupon: 'Keep',
      confirmCancelCoupon: 'Confirm cancel',
      personalInfoTitle: 'Thank you for booking flights with Interest-free travel.',
      personalInfoBody: "When you book domestic flights, Interest-free travel shares your selected products and personal information with the issuing airline. For international bookings, your information is provided to the overseas airline to verify identity and fulfill the order. (See issuer details at the bottom of the booking page and airline conditions in order details.) Before sharing data, we comply with PRC Personal Information Protection Law and our privacy policy. Service providers may only use your data to deliver the service. Contact our privacy team at wujinbao{'@'}wujinbao.net for data rights requests. By submitting your order, you authorize Interest-free travel to share necessary personal information with domestic/overseas service providers.",
      passengerIdNotice: 'Airlines require passenger ID at booking and check-in. Please ensure information is accurate. Interest-free travel encrypts ID data and shares it only with authorized suppliers, carriers, and distribution systems.',
      agreeTreatyPrefix: 'I have read and accept',
      agreeTreatySuffix: ', ',
      agreePersonalInfo: 'Personal data authorization',
      adultCount: '{count} adult(s)',
      childCount: '{count} child(ren)',
      fillOrder: 'Complete booking',
      contactInfoBodyLong:
        'This contact receives order change notices. We recommend using your own mobile number so you are notified promptly and your trip is not affected.',
      contactInfoNoteLong:
        'Note: changes include schedule adjustments, cancellations, merges, air traffic control, airport or weather delays, and load factors.',
      passengerIdNoticeFill:
        'Airlines require passenger ID at booking and at check-in. Please ensure information is accurate. Interest-free travel encrypts ID data and shares it only with authorized suppliers, carriers, and distribution systems.',
      adultPriceWithTax: 'Adult ¥{ticket} + taxes ¥{tax}',
      childPriceWithTax: 'Child ¥{ticket} + taxes ¥{tax}',
      adultCountShort: '{count} adult(s)',
      childCountShort: '{count} child(ren)',
      priceTimesCount: '¥{price}×{count}',
      priceTimesPersonCount: '¥{price}×{count} passenger(s)',
      noCouponShort: 'None available',
      specifiedBank: 'selected bank',
      flightPopupDuration: '{date} · duration {duration}',
      couponFullReduction: 'Spend ¥{minAmount}, save ¥{amount}',
      couponInstantReduction: 'Instant ¥{amount} off',
      couponFullDiscount: 'Spend ¥{minAmount}, {discount}/10 off',
      couponDiscountOff: '{discount}/10 off',
      delayInsuranceShort: 'Flight delay insurance',
      routeConnector: ' - ',
    },
    passenger: {
      cardType: 'ID type',
      nationality: 'Nationality',
      selectNationality: 'Select nationality',
      surname: 'Surname',
      surnamePlaceholder: 'Surname (Pinyin/English)',
      givenName: 'Given name',
      givenNamePlaceholder: 'As on travel document',
      givenNameIntlPlaceholder: 'Given name (Pinyin/English)',
      cardExpired: 'ID expiry date',
      selectCardExpired: 'Select expiry date',
      birthday: 'Date of birth',
      selectBirthday: 'Select date of birth',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      email: 'Email',
      emailPlaceholder: 'Enter email',
      issuingAirline: 'Issuing airline',
      selectAirlineOptional: 'Select airline (optional)',
      frequentFlyerNo: 'Frequent flyer no.',
      frequentFlyerPlaceholder: 'Frequent flyer no. (optional)',
      readCarefully: 'Please read carefully',
      savePassenger: 'Add passenger',
      editPassenger: 'Edit passenger',
      savePolicyholder: 'Add policyholder',
      editPolicyholder: 'Edit policyholder',
      selectCardType: 'Select ID type',
      selectAreaCode: 'Select country code',
      searchCountry: 'Search country',
      searchAreaCode: 'Search country code',
      searchAirline: 'Search airline',
      loadingMore: 'Load more…',
      noMoreData: 'No more data',
      selectAirport: 'Select airport',
      datePickerYear: '',
      datePickerMonth: '',
      datePickerDay: '',
      cardTypeNI: 'Resident ID card',
      cardTypePP: 'Passport',
      cardTypeOT: 'Other',
      cardTypeHM: 'HK/Macao/TW residence permit',
      cardTypeHMP: 'HK/Macao travel permit',
      cardTypeHR: 'Household register',
      cardTypeHX: 'Home return permit',
      cardTypeTB: 'Taiwan compatriot permit',
      cardTypeTP: 'Taiwan travel permit',
      cardTypeJR: 'Military ID',
      cardTypeBC: 'Birth certificate',
    },
    select: {
      searchCity: 'Enter city',
      tabDomestic: 'Mainland China',
      tabHmt: 'HK / Macao / Taiwan',
      tabOverseas: 'Overseas',
      currentHistory: 'Current / history',
      currentNearbyTitle: 'Current city / Nearby airports',
      historyTitle: 'History (domestic & international)',
      straightLineDistance: '{distance} km away',
      clearHistory: 'Clear history',
      hotCities: 'Popular cities',
      confirmMulti: 'Confirm',
      maxThree: 'Select up to 3',
      alreadySelected: 'Already selected',
      sameCityError: 'Departure and destination must differ',
      intlSameMainlandError: 'Intl routes cannot be two mainland China cities',
      noAirportInfo: 'No airport data — city will be used',
      loadCityFailed: 'Failed to load cities',
      loadContinentFailed: 'Failed to load regions',
      loadCountryFailed: 'Failed to load countries',
      searchFailed: 'Search failed',
      loadAirportFailed: 'Failed to load airports',
      searchSectionAirport: 'Airports',
      searchSectionCity: 'Cities',
      searchSectionCountry: 'Countries & regions',
      searchSameCityTag: 'Same city',
    },
    guide: {
      title: 'Flight guide',
      subtitle: 'Tips for booking, security, and boarding',
      tabBuy: 'Booking',
      tabAirport: 'At the airport',
      tabSecurity: 'Security & boarding',
      tabBoarding: 'Boarding',
      tabChangeRefund: 'Changes & refunds',
      fraudAlert: '[Important] Beware of refund/scam calls. If you receive schedule change or refund messages, contact the airline or Interest-free travel. Never share card passwords or verification codes.',
      servicePhone: 'Interest-free travel: {phone}',
      buy: {
        title: 'Booking',
        body: 'After booking, confirm your departure airport and terminal. For example, Beijing has Daxing and Capital airports; Capital has T1, T2, and T3. Different airlines use different terminals — follow your ticket and avoid going to the wrong airport.',
      },
      airport: {
        title: 'At the airport',
        arriveTimeTitle: 'Arrival time',
        arriveTimeBody: 'Arrive at the airport about 2 hours before domestic departure.',
        validIdTitle: 'Valid ID',
        validIdBody: 'Bring the original ID used for booking. For children booked with household register, bring the original register. If you forget ID, apply for a temporary boarding pass at the airport police office.',
        boardingPassTitle: 'Boarding pass & checked baggage',
        boardingPassBody: 'Present your ID at the airline counter for your flight to get a boarding pass. Check in baggage at the same counter if needed.',
        powerBankTitle: 'Power banks & baggage size',
        powerBankBody: 'Power banks must be carry-on only (not checked), max 20,000 mAh. Economy usually includes 20 kg checked baggage; carry-on max 20×40×55 cm and 5 kg. Rules vary by airline — check your order or contact the airline. Extra baggage can be purchased online or at the airport.',
      },
      security: {
        title: 'Security & boarding',
        intro: 'Present boarding pass and ID, pass security, and wait in the departure hall.',
        dailyItemsTitle: 'Daily items',
        dailyItemsBody1: 'Liquids such as cleanser, shampoo, and toothpaste: max 100 ml per container; larger volumes must be checked. A 50 ml bottle in a 150 ml container is not allowed.',
        dailyItemsBody2: 'For medicine, plants, or pets, contact the airline.',
        dailyItemsBody3: 'Beverages, alcohol, lighters, and everyday knives are not allowed in carry-on.',
      },
      boarding: {
        title: 'Boarding',
        body: 'Go to the gate shown on your boarding pass. Wait at the correct gate and board at the announced time.',
      },
      changeRefund: {
        title: 'Changes & refunds',
        itineraryChangeTitle: 'Schedule change',
        itineraryChangeBody: 'If plans change, open the order and request refund or change.',
        feeTitle: 'Change & refund fees',
        feeBody: 'See [Refund & change rules] in order details.',
      },
    },
    treaty: {
      heroTag: 'Safe travel notice',
      heroTitle: 'Dangerous goods policy',
      heroDesc: 'Read lithium battery, power bank, and dangerous goods rules before departure to board smoothly.',
      section1: {
        title: 'I. CAAC notice on lithium batteries in passenger baggage',
        badge: 'Battery safety',
        p1: 'To strengthen lithium battery safety in air transport, CAAC and regional authorities issued notices requiring airlines and airports to manage lithium batteries in passenger baggage per ICAO Technical Instructions for the Safe Transport of Dangerous Goods:',
        p2: 'Portable electronic devices with lithium or lithium-ion batteries (power banks, watches, calculators, cameras, phones, laptops, camcorders) for personal use must be in carry-on baggage. Lithium metal content max 2 g; lithium-ion rated energy max 100 Wh. Over 100 Wh but ≤160 Wh requires airline approval in carry-on. Over 160 Wh is prohibited.',
        p3: 'Spare batteries must be individually protected against short circuit (original retail packaging, taped terminals, or separate bags/boxes) and may only be in carry-on baggage. Approved 100–160 Wh spare batteries: max two per passenger.',
        p4: 'Power banks with on/off switches must be off in flight. Do not charge devices or use other power bank functions in flight.',
        p5: 'Wheelchairs and portable medical devices with lithium batteries must comply with Technical Instructions and require airline approval.',
      },
      appendix: {
        title: 'Appendix: Lithium battery safety tips',
        badge: 'Operating rules',
        allowedTitle: 'I. Permitted lithium batteries',
        allowedP1: 'Laptops, phones, cameras, watches, and other personal portable electronics with ≤100 Wh batteries may be carried in cabin and as spares.',
        allowedP2: 'Typical phone batteries: 3–10 Wh; DSLR: 10–20 Wh; camcorder: 20–40 Wh; laptop: 30–100 Wh. Most consumer devices stay under 100 Wh.',
        restrictedTitle: 'II. Restricted lithium batteries',
        restrictedP1: 'With airline approval, devices with >100 Wh but ≤160 Wh may be carried. Max two such spares per passenger; not in checked baggage.',
        restrictedP2: 'May include media equipment, film gear, performance props, medical devices, electric toys/tools, toolboxes, etc.',
        forbiddenTitle: 'III. Prohibited lithium batteries',
        forbiddenP1: 'Batteries or devices over 160 Wh are prohibited in carry-on and checked baggage.',
        protectTitle: 'IV. Spare battery protection',
        protectP1: 'Spare batteries must be individually protected (original packaging, taped terminals, or separate bags/boxes).',
        calcTitle: 'V. How to determine rated energy',
        calcP1: 'If Wh is not marked on the battery, rated energy may be calculated as follows:',
        calcP2: '1. If nominal voltage (V) and capacity (Ah) are known: Wh = V × Ah. Voltage and capacity are usually on the label.',
        calcP3: '2. If only mAh is marked, divide by 1000 for Ah. Example: 3.7 V, 760 mAh → 0.76 Ah; 3.7 × 0.76 = 2.9 Wh.',
      },
      powerBank: {
        title: 'Notice on carrying power banks on flights',
        badge: 'Power bank guide',
        intro: 'Power banks are lithium battery packs mainly used to charge phones and other devices. Per ICAO Technical Instructions and CAAC dangerous goods rules, passengers must follow:',
        rule1: 'I. Power banks must be for personal use only.',
        rule2: 'II. Carry-on or on person only — never in checked baggage.',
        rule3: 'III. ≤100 Wh: no approval needed. >100 Wh but ≤160 Wh: airline approval required; max two per passenger.',
        rule4: 'IV. Over 160 Wh or unmarked/un calculable energy: prohibited.',
        rule5: 'V. Do not use power banks to charge devices in flight. Keep switches off during flight.',
        rule6: 'The above applies to crew as well.',
        rule7: 'Effective upon publication.',
        calcTitle: 'Appendix: Power bank rated energy',
        calcP1: 'If Wh is not marked on the power bank, rated energy may be calculated as follows:',
        calcP2: '1. If nominal voltage (V) and capacity (Ah) are known: Wh = V × Ah. Voltage and capacity are usually on the label.',
        calcP3: '2. If only mAh is marked, divide by 1000 for Ah. Example: 3.7 V, 760 mAh → 0.76 Ah; 3.7 × 0.76 = 2.9 Wh.',
      },
      section2: {
        title: 'II. Prohibited dangerous goods',
        badge: 'Must read',
        p1: 'For items with hidden hazards, consult airline or airport staff.',
        p2: 'Alcohol, liquids, and personal lithium devices and spare batteries must comply with CAAC rules.',
      },
      balanceCar: {
        title: 'Notice on small lithium battery vehicles',
        badge: 'Balance vehicle alert',
        body: 'Due to fire risk from lithium batteries, self-balancing vehicles powered by lithium batteries are prohibited in carry-on and checked baggage. This includes but is not limited to: unicycles, electric skateboards, hoverboards, smart scooters, Segways, camera dolly vehicles, etc.',
      },
    },
    luggage: {
      title: 'Baggage rules',
      domesticTitle: 'Domestic baggage rules',
      subtitle: 'For reference only; follow airport and airline rules.',
      tabs: {
        common: 'Common items',
        electronics: 'Electronics',
        toiletries: 'Toiletries',
        food: 'Food',
        special: 'Special baggage',
        tools: 'Tools',
      },
      table: {
        itemName: 'Item',
        carryOn: 'Carry-on',
        checked: 'Checked',
        sectionTitle: 'Which common items are restricted?',
      },
      status: {
        allowed: '✓',
        forbidden: '✗',
      },
      commonItems: {
        lighter: { name: 'Lighters, matches' },
        selfHeating: { name: 'Self-heating hot pots' },
        sprayCan: { name: 'Aerosol sunscreens / pressure cans' },
        disinfectant: { name: 'Disinfectants with isopropanol' },
        powerBank: { name: 'Power bank', carry: '≤20,000 mAh' },
        electricToothbrush: { name: 'Electric toothbrush' },
        phone: { name: 'Phone' },
        earphones: { name: 'Bluetooth earphones', carry: 'Do not use during takeoff/landing' },
        laptop: { name: 'Laptop / tablet', check: 'Some airlines allow checked if powered off' },
        dailyKnife: { name: 'Everyday knives' },
        longUmbrella: { name: 'Umbrella over 1 m' },
        thermometer: { name: 'Mercury thermometer', check: 'One allowed checked with protective case' },
        cosmetics: { name: 'Liquid toiletries / cosmetics', carry: 'Container ≤100 ml', check: 'No flammable label' },
        alcohol: { name: 'Alcohol', check: 'Degree and volume limits apply' },
        selfieStick: { name: 'Selfie stick / tripod', carry: 'Folded <25 cm, tube <1 cm' },
        liquidMedicine: { name: 'Liquid medicine (e.g. insulin)', carry: 'Reasonable amount for flight; medical proof recommended' },
        medicalMask: { name: 'Medical masks, goggles, protective suits' },
        handWarmer: { name: 'Hand warmers', carry: 'Per airline/airport security', check: 'Per airline/airport security' },
        jewelry: { name: 'Jewelry and valuables', check: 'Not recommended checked; carry on' },
      },
      electronics: {
        powerBankTitle: 'Power bank',
        noElectronicsTitle: 'Appliances without lithium batteries',
        samsungTitle: 'Samsung Galaxy Note 7',
        noElectronicsItems: 'Plug-in hair dryer, curling iron, flat iron, battery toothbrush with dry cells, etc.',
        powerBankRules: {
          r1: 'From Jun 28, 2025: no 3C mark, unclear mark, or recalled models/batches (see note 1) allowed on board.',
          r2: 'Carry-on only; must stay off in flight.',
          r3: '≤100 Wh allowed (typically ≤20,000 mAh at ≤5 V).',
          r4: '>100 Wh but ≤160 Wh requires airline approval on site.',
          r5: '>160 Wh prohibited (typically >32,000 mAh). Formula: Wh = V × Ah. Example: 10,000 mAh at 5 V = 50 Wh.',
        },
        recallIntro: 'Recalled power banks (as of 2025/6/24):',
        recallRomoss: 'ROMOSS:',
        recallRomoss1: '① Model PAC20-272, batches: C14-P6/P7, M14-P6/P7, C13-P6/P7, M20-Q1/Q2, M14-Q1/Q2, C14-Q1/Q2',
        recallRomoss2: '② Model PAC20-392, batches: M14-Q6/Q7, C13-Q6/Q7, M20-Q6/Q7, M22-Q6/Q7',
        recallRomoss3: '③ Model PLT20A-152, batch: M20-P8/Q1',
        recallAnker: 'Anker recalled models:',
        recallAnkerModels: 'A1642/A1647/A1652/A1680/A1681/A1689/A1257',
        note2: 'Power banks must be carry-on; never checked.',
        note3: 'Max two power banks per passenger; protect against short circuit.',
        note4: 'Capacity and voltage must be marked on packaging; otherwise prohibited.',
        note5: 'Fully off in flight; prevent accidental activation and damage.',
      },
      toiletries: {
        liquidItemsTitle: 'Liquid items',
        liquidRule: 'One of each cosmetic type; container ≤100 ml or 100 g; total ≤1000 ml; subject to inspection.',
        flammableTitle: 'Flammable contents',
        flammableR1: 'Some airports prohibit checked baggage.',
        flammableR2: 'Aerosol sunscreen and metal pressure cans cannot be checked.',
        categories: {
          liquid: 'Water-based',
          liquidItems: 'Toner, hand sanitizer, serum, lotion, mouthwash, contact lens solution',
          cream: 'Lotion',
          creamItems: 'Cleanser, body lotion, shower gel, shampoo',
          oil: 'Oil-based',
          oilItems: 'Cleansing oil, essential oil, lubricant, skin oil',
          paste: 'Cream',
          pasteItems: 'Face cream, sunscreen',
          ointment: 'Paste',
          ointmentItems: 'Toothpaste, shaving cream, Vaseline, ointment, mascara',
          gel: 'Gel',
          gelItems: 'Aloe gel',
          spray: 'Spray',
          sprayItems: 'Non-pressurized facial mist',
          foam: 'Foam',
          foamItems: 'Shaving foam, etc.',
          sheet: 'Sheet',
          sheetItems: 'Face masks, wet wipes, etc.',
          flammable: 'Flammable',
          flammableItems: 'Toilet water, essential balm, cooling spray, perfume, hand sanitizer, nail polish, remover, hair wax, etc.',
          explosive: 'Explosive',
          explosiveItems: 'Metal pressure cans or items labeled flammable/explosive: hair spray, mousse, sunscreen spray, etc.',
        },
      },
      food: {
        freshTitle: 'Fresh food',
        freshRule: 'Strong-smelling perishables prohibited; others per airline/airport rules.',
        sameAsCheckin: 'Same as checked restrictions',
        freshItems1: 'Strong-smelling perishables: raw eggs, durian, unsealed cured meat, etc.',
        freshItems2: 'Liquids over 100 ml: coconut, etc.',
        selfHeatingTitle: 'Self-heating food',
        selfHeatingItems: 'Self-heating hot pot, self-heating rice meals',
        liquidFoodTitle: 'Liquid food',
        liquidFoodItems: 'Hot pot base, ice cream, herbal jelly, honey, cooking oil, chili sauce, bean paste, canned food, liquor-filled chocolate, water, drinks, pickles, etc.',
        liquidFoodNote: 'Hot water is available on board. For infant formula, use hot water on board or request airline liquid dairy/infant meal.',
        alcoholTitle: 'Alcohol',
        alcoholR1: 'Clearly labeled, in retail bag; container ≤5 L.',
        alcoholR2: 'Below 24% ABV: no checked limit.',
        alcoholR3: '24%–70% ABV: max 5 L checked per passenger.',
        alcoholR4: 'Above 70% ABV: prohibited checked.',
        alcoholItems: 'Baijiu, red wine, wine, etc.',
        otherFoodTitle: 'Other food',
        otherFoodRule: 'Seafood etc. not allowed as carry-on',
      },
      special: {
        wheelchairTitle: 'Wheelchair / stroller',
        airlineRule: 'Per airline and airport security rules',
        instrumentTitle: 'Musical instruments',
        instrumentR1: 'Max 40×60×100 cm; buy extra seat if larger',
        instrumentR2: 'Within 7 kg and 40×60×100 cm for carry-on',
        orderAllowanceNote: 'Subject to order baggage allowance',
        petTitle: 'Pets',
        petRule: 'Per airline/airport rules; contact airline or airport in advance',
        petNote: 'Pets means household cats/dogs (not wildlife or dangerous animals such as snakes)',
        liquidMedicineTitle: 'Liquid medicine',
        liquidMedicineItems: 'Insulin etc.: after security check, reasonable amount for flight; excess must be checked. Medical certificate recommended for other medicines.',
        pesticideTitle: 'Pesticides',
        pesticideR1: 'Toxic pesticides (oxides, arsenic, etc.) prohibited checked and carry-on',
      },
      tools: {
        knifeTitle: 'Knives',
        knifeR1: 'Controlled knives: tip angle <60°, blade >150 mm',
        knifeR2: 'Prohibited checked',
        sportsTitle: 'Tools / sports equipment',
        categories: {
          professional: 'Professional knives',
          professionalItems: 'Scalpel, carving knife, cleaver, chisel, milling cutter, performance swords/spears, etc.',
          daily: 'Everyday knives',
          dailyItems: 'Kitchen knife, fruit knife, scissors, utility knife, paper cutter, etc.',
          sports: 'Sports equipment',
          sportsItems: 'Fitness gear, golf clubs, ski gear, fishing gear, knuckles, trekking poles, etc.',
          construction: 'Construction tools',
          constructionItems: 'Chisel, awl, saw, nail gun, screwdriver, crowbar, hammer, pliers, welding torch, etc.',
        },
      },
      footer: {
        endHint: 'End of baggage rules',
        tapHint: 'Tap a category above',
        lastChapter: 'Last section',
      },
    },
    remind: {
      tabRoute: 'Route',
      tabFlight: 'Flight',
      monitorCount: 'Low fares found for {count} users today',
      monitor247: '24/7 monitoring',
      currentPrice: 'Current',
      departDateRange: '{start} – {end}',
      departOn: 'Depart {date}',
      remainOne: '1 seat left',
      watchRoutesTitle: 'Watched routes',
      watchRoutesTip: '| Alert when price drops',
      swipeEditDelete: '← Swipe to edit/delete',
      swipeDelete: '← Swipe to delete',
      addLowPriceAlert: 'Add price alert',
      addReminderBanner: 'Get notified when price drops',
      addReminder: 'Add alert',
      viewMore: 'View more',
      priceRising: 'Prices may rise — book soon',
      ticketsTight: 'Few seats left',
      monitoringStatus: 'Monitoring',
    },
    lowPrice: {
      tabDh: 'China Eastern deals',
      tabNh: 'China Southern low fares',
      tabZlh: 'China United low fares',
      tabGh: 'Air China low fares',
      tabGlh: 'Guilin Airlines low fares',
      departWeekday: 'Depart {date} ({weekday})',
    },
    week: {
      title: '{month} weekend getaway',
      monthWeekend: '{month} weekend',
      maxLeaveDays: 'Max {count} leave day(s)',
      playDays: '{min}-{max} day trip',
      askLeave: 'Time off',
      weekend: 'Weekend',
      askDays: 'Take {count} day(s) off',
      playDaysShort: '{count}-day trip',
      roundTotal: 'Round-trip total',
      weekN: 'Week {count}',
      moreStrategies: 'More getaway tips',
      goDepart: 'Thu depart {date}',
      returnOn: 'Sat return {date}',
      priceFrom: 'From ¥{price}',
    },
    area: {
      title: 'Regional low fares',
      oneWay: 'One-way',
      roundTrip: 'Round trip',
      departRange: '{start}–{end} depart',
      moreFlights: 'More flights',
      filter: 'Filter',
    },

    intlOrder: {
      fillOrder: 'Fill order',
      intlIdOnly: '(Intl travel documents only)',
      unavailableTag: 'Unavailable',
      journeyCount: '({count} legs)',
      contactEmail: 'Contact email',
      emailReceiptPlaceholder: 'For e-ticket itinerary',
      priceLineAdult: 'Adult ¥{ticket} + tax ¥{tax}',
      priceLineChild: 'Child ¥{ticket} + tax ¥{tax}',
      priceLineInfant: 'Infant ¥{ticket} + tax ¥{tax}',
      priceTimesCopies: '¥{price}×{count}',
      infantCountShort: '{count} infant(s)',
      passengerTypeSelectableLabel: 'Selectable types',
      cabinWithTax: '{cabin} (tax incl.)',
      taxExplainTitle: 'Taxes & fees',
      taxExplainIntro: 'Taxes include airport construction fee and fuel surcharge.',
      taxFuelIntlTitle: '2. Fuel surcharge',
      taxFuelIntlBody:
        'International fuel surcharges are set by the airline and may vary by route and carrier.',
      stopoverPrefix: 'Stopover:',
      intlAccidentInsuranceFallback: 'Intl flight accident insurance',
      transferUnknown: 'Unknown',
      transferCalcError: 'Calculation error',
      personalInfo: {
        sectionInfoUse: 'Information use',
        sectionInfoUseBody:
          'When you book a domestic ticket, 0息游 will provide your selected products and personal information to the domestic airline. When you book an international ticket, the same information will be provided to the overseas airline to verify your identity, confirm your order, and deliver the service.',
        sectionAirlineQuery: 'Airline information',
        sectionAirlineQueryBody:
          '(You can view the issuer name and business license at the bottom of the booking page, or open the airline transport conditions link on the order detail page for airline contact details.)',
        sectionPrivacy: 'Personal information protection',
        sectionPrivacyBody:
          'Before sharing information, 0息游 follows the Personal Information Protection Law and our Privacy Policy, requiring service providers to process data only for providing the service and not to transfer, share, sell, or otherwise use your data without authorization.',
        sectionContact: 'Contact',
        sectionContactBody:
          'For requests regarding your personal information, including rights related to cross-border transfers, email us at wujinbao{\'@\'}wujinbao.net.',
        sectionConsent:
          'Please review your selected products and personal information again. By tapping Submit order, you agree that 0息游 may provide your information to relevant domestic/overseas service providers.',
      },
      priceChange: {
        title: 'Price updated',
        desc: 'The airline fare has changed. The page shows the latest price. Continue booking?',
        oldPrice: 'Previous fare',
        newPrice: 'Latest fare',
        research: 'Search again',
        continueBook: 'Continue',
      },
      toast: {
        passengerTypeUnsupported: 'This flight does not support {type} passengers',
        passengerCardTypeInvalid: 'Passengers {names}: ID type not accepted by the airline',
        passengerNationalityInvalid: 'Passengers {names}: nationality not accepted by the airline',
        passengerNationalityBanned: 'Passengers {names}: nationality restricted by the airline',
        passengerAgeInvalid: 'Passengers {names}: age not accepted by the airline',
        fillContact: 'Please enter contact name',
        selectPhoneAreaCode: 'Please select phone country code',
        fillPhone: 'Please enter contact phone',
        phoneDigitsOnly: 'Phone number may contain digits only',
        fillEmail: 'Please enter contact email',
        invalidEmailFormat: 'Please enter a valid email address',
        submitFailRetry: 'Order submission failed. Please try again later.',
        priceChangedRetry: 'Price changed. Please search again.',
        missingQuote: 'Missing fare data. Please go back and try again.',
        insuranceLoadFail: 'Failed to load insurance',
        insuranceLoadFailRetry: 'Failed to load insurance. Please try again later.',
      },
    },

    intlOrderDetail: {
      orderNoLabel: 'Order No.:',
      copy: 'Copy',
      payRemainTime: 'Time left to pay',
      payRemainHint: 'Please pay soon to avoid automatic cancellation',
      refundedAmount: 'Refunded ¥{amount}',
      refundEta: 'Estimated refund arrival: {time}',
      refundProgress: 'Refund progress',
      totalAmount: 'Total ¥{amount}',
      orderRecord: 'Order history',
      priceDetail: 'Price details',
      refundChangeRules: 'Change & refund rules',
      status: {
        unknown: 'Unknown',
        pendingPay: 'Pending payment',
        ticketing: 'Issuing',
        ticketSuccess: 'Issued',
        ticketFail: 'Issue failed',
        cancelled: 'Cancelled',
        partialRefunding: 'Partial refund in progress',
        partialRefunded: 'Partially refunded',
        refunding: 'Refunding',
        refunded: 'Refunded',
      },
      changeFlightInfo: 'Changed flight',
      changePassengers: 'Changed passengers:',
      transfer: 'Transfer',
      transferWithTime: 'Transfer {time}',
      viewDetail: 'View details',
      changePersonCount: '{count} changed',
      passengerRefund: '{name} refund',
      flightInfo: 'Flight info',
      flightLabel: 'Flight:',
      departLabel: 'Depart:',
      tripN: 'Trip {n}',
      journey1: 'Leg 1',
      journey2: 'Leg 2',
      journey3: 'Leg 3',
      journey4: 'Leg 4',
      journey5: 'Leg 5',
      journeyNth: 'Leg {n}',
      preTravelMustRead: 'Before you travel',
      fraudReminder: 'Anti-fraud tips',
      civilizedBoarding: 'Boarding etiquette',
      purchasedServices: 'Purchased / complimentary',
      insurance: 'Insurance',
      purchased: 'Purchased',
      travelerInfo: 'Travelers',
      ticketNo: 'Ticket No.:',
      ticketNoValue: 'Ticket No.: {no}',
      detail: 'Details',
      noTravelers: 'No traveler info',
      contactTitle: 'Contact',
      contactName: 'Contact name',
      mobile: 'Mobile',
      email: 'Email',
      usedCoupon: 'Coupon used',
      unionPointTitle: 'UnionPay points',
      unionPointUsed: 'Points used',
      unionPointDeduct: 'Points discount',
      unionPointRefunded: 'Points refunded',
      unionPointCount: '{count} pts',
      goPay: 'Pay now',
      refundTicket: 'Refund',
      rebook: 'Book again',
      refundRecords: 'Refund records',
      change: 'Change',
      issueInvoice: 'Request invoice',
      viewInvoice: 'View invoice',
      noRefundRecords: 'No refund records',
      noRefundProgressRecords: 'No refund progress',
      noTimeInfo: 'No time info',
      refundPassengers: 'Refund passengers:',
      refundSegments: 'Refund segments:',
      refundAmount: 'Refund amount:',
      viewProgress: 'View progress',
      ticketPrice: 'Fare',
      taxFee: 'Taxes',
      serviceFee: 'Service fee',
      insuranceTotal: 'Insurance total:',
      couponDeduct: 'Coupon discount',
      originalPrice: 'Original',
      payablePrice: 'Amount due',
      eInvoiceSupport: 'E-invoice available for this order',
      ruleTimeHint: 'Expired periods are grayed out. Actual fees follow airline rules.',
      followAirlinePolicy: 'Subject to airline policy',
      carryOn: 'Carry-on',
      checkedBaggage: 'Checked baggage',
      baggagePiece: '{count} pc(s), {weight}{unit} each',
      baggageSize: ', size: {size}',
      baggageDesc: ', {desc}',
      fraud: {
        title: 'Anti-fraud tips',
        alert: 'Watch out for air-travel scams',
        typeChange: 'Change/refund scams',
        typeChangeBody: 'Scammers pose as airline staff, claim delays or cancellations, and push you to change or refund privately to steal money.',
        typeFakeTicket: 'Fake ticket scams',
        typeFakeTicketBody: 'Scammers advertise fake cheap fares and push payment on unofficial channels, then never issue tickets.',
        typeOverweight: 'Baggage overweight scams',
        typeOverweightBody: 'Scammers pose as airport staff, claim overweight bags, and ask you to scan a QR code to pay.',
        typeFakeClaim: 'Fake claim scams',
        typeFakeClaimBody: 'Scammers pose as airline staff offering complaint compensation and ask for bank card details.',
        tipsTitle: 'How to stay safe',
        tip1: '1. Book and change only via official airline channels or trusted platforms',
        tip2: '2. Do not trust change/refund notices from unknown calls or SMS',
        tip3: '3. Never transfer money or share bank cards/verification codes with strangers',
        tip4: '4. Pay airport fees at official counters only—do not scan suspicious QR codes',
        tip5: '5. If anything looks suspicious, call the CAAC hotline or the police',
      },
      civilized: {
        title: 'Boarding etiquette',
        intro: 'To keep flights safe and on time and ensure a comfortable trip for everyone, please follow these rules:',
        prepareTitle: 'Before departure',
        prepare1: '1. Check your flight details and allow enough time for check-in',
        prepare2: '2. Watch flight status for delays or cancellations',
        prepare3: '3. Know baggage limits and prohibited items',
        prepare4: '4. Bring a valid travel ID that is still in date',
        securityTitle: 'Security & boarding',
        security1: '1. Cooperate with security checks and present your documents politely',
        security2: '2. Board in order—no cutting or crowding',
        security3: '3. Stow carry-on properly without taking others space',
        security4: '4. Set phones to airplane mode or power off and follow electronics rules',
        etiquetteTitle: 'Onboard manners',
        etiquette1: '1. Fasten your seat belt and follow crew safety instructions',
        etiquette2: '2. Keep noise down; use headphones for media',
        etiquette3: '3. Respect others space—do not recline abruptly',
        etiquette4: '4. Keep the cabin clean; put trash in bags',
        etiquette5: '5. Treat crew and fellow passengers politely',
        forbidTitle: 'Strictly prohibited',
        forbid1: '1. No smoking or e-cigarettes in the cabin',
        forbid2: '2. No drunk and disorderly behavior',
        forbid3: '3. Do not misuse or damage safety equipment',
        forbid4: '4. Do not interfere with crew duties',
        forbid5: '5. Do not carry or falsely declare prohibited items',
        legalNote: 'Under the Civil Aviation Law of the PRC and related security regulations, disrupting cabin order, obstructing crew, or endangering flight safety may lead to penalties; serious cases may be recorded as passenger misconduct.',
      },
      ticketInfo: 'Ticket info',
      orderChangeRecord: 'Order change history',
      noOrderChangeRecord: 'No order changes',
      passengerLabel: 'Passenger:',
      selectInvoiceType: 'Select invoice type',
      insuranceInvoice: 'Insurance invoice',
      planeInvoice: 'Flight invoice',
      noInsuranceInvoice: 'No insurance invoices',
      durationHm: '{h}h {m}m',
      durationH: '{h}h',
      durationM: '{m}m',
      monthDayTime: '{month}/{day} {time}',
      free: 'Free',
      nonRefundable: 'Non-refundable',
      nonChangeable: 'Non-changeable',
      priceFrom: 'From ¥{price}',
      ruleTimeAfterDep: 'After departure (after {date})',
      ruleTimeAllBefore: 'Any time before departure (before {date})',
      ruleTimeAny: 'Any time',
      ruleTimeAfterHours: 'Within {h}h before departure (after {date})',
      ruleTimeBeforeHours: 'More than {h}h before departure (before {date})',
      ruleTimeAfterHoursIncl: 'Within {h}h before departure incl. (from {date})',
      ruleTimeBeforeHoursIncl: 'More than {h}h before departure incl. (until {date})',
      idType: {
        '1': 'ID card',
        '2': 'Passport',
        '3': 'Military ID',
        '4': 'Seafarer ID',
        '5': 'HK/Macao permit',
        '6': 'Taiwan permit',
        '7': 'Taiwan compatriot permit',
        '8': 'Home return permit',
        '9': 'Student',
        '10': 'Foreign residence permit',
        '11': 'Other',
        fallback: 'ID',
      },
      refundOrderStatus: {
        '0': 'Pending review',
        '1': 'Pending confirm',
        '2': 'Rejected',
        '3': 'Refunding',
        '4': 'Refunded',
        '5': 'Cancelled',
      },
      changeOrderStatus: {
        '0': 'Pending review',
        '1': 'Pending payment',
        '2': 'Rejected',
        '3': 'Issuing',
        '4': 'Changed',
        '5': 'Cancelled',
      },
      recordType: {
        '0': 'Booked flight',
        '1': 'Applied refund',
        '2': 'Applied change',
        unknown: 'Unknown',
      },
      unknownPassenger: 'Unknown passenger',
      unknownSegment: 'Unknown segment',
      unknownType: 'Unknown',
      toast: {
        loadDetailFail: 'Failed to load order details',
        loadDetailFailRetry: 'Failed to load order details — please try again',
        payIncomplete: 'Incomplete order — cannot pay',
        noOrderNoCopy: 'No order number to copy',
        viewRefundDetail: 'View refund details',
        noChangeable: 'No changeable tickets on this order',
        noRefundable: 'No refundable tickets on this order',
        rebookIncomplete: 'Incomplete order — cannot rebook',
        rebookNoJourney: 'Missing journey info — cannot rebook',
        navigateFail: 'Navigation failed — please try again',
        operateFail: 'Operation failed — please try again',
        cancelSuccess: 'Cancelled',
        noIdCopy: 'No ID number to copy',
        noTicketCopy: 'No ticket number to copy',
        noPhoneCopy: 'No phone number to copy',
        noEmailCopy: 'No email to copy',
        refundDetailIncomplete: 'Incomplete refund info — cannot open details',
        refundProgressIncomplete: 'Incomplete refund info — cannot open progress',
        changeDetailIncomplete: 'Incomplete info — cannot open change details',
        detailIncomplete: 'Incomplete info — cannot open details',
        insuranceInvoiceFail: 'Failed to load insurance invoices',
        insuranceInvoiceFailRetry: 'Failed to load insurance invoices — please try again',
        missingOrderNo: 'Missing order number — cannot query',
        noOrderNoInvoice: 'Order number missing — cannot open invoice',
      },
      dialog: {
        tip: 'Notice',
        cancelOrder: 'Cancel this order?',
      },
    },

    intlDetail: {
      layover: 'Layover {duration}',
      actualRide: 'Operated by {airline}{flightNo}',
      fareTaxLine: 'Fare: ¥{ticket} + taxes: ¥{tax}',
      select: 'Select',
      ticketIssueFast: 'Express issue',
      ticketIssuePriority: 'Priority issue',
      ticketIssueStandard: 'Standard issue',
      ticketIssueEconomy: 'Economy issue',
      ticketTimeDefault: 'Standard issue',
      ticketTimeFast: 'Express (30 min)',
      ticketTimePriority: 'Priority (60 min)',
      ticketTimeStandard: 'Standard (2 h)',
      ticketTimeEconomy: 'Economy (48 h+)',
      cabinPremiumEconomy: 'Premium economy',
      cabinFirst: 'First class',
      purchaseLimitTitle: 'Purchase restrictions',
      ageLimit: 'Age limit: {value}',
      allowBuyNationality: 'Allowed nationalities: {value}',
      prohibitBuyNationality: 'Restricted nationalities: {value}',
      ageRequirement: 'Age requirement: {value}',
      allowNationality: 'Allowed nationalities: {value}',
      restrictNationality: 'Restricted nationalities: {value}',
      allowDocument: 'Allowed documents: {value}',
      toast: {
        fetchFail: 'Failed to load flight data',
        fetchFailRetry: 'Failed to load flight data — please try again',
        missingParams: 'Missing required parameters — cannot load flight data',
      },
    },

    intlList: {
      modifyDate: 'Change date',
      selectedFlights: 'Selected flights',
      segmentCount: '{count} segment(s)',
      reselect: 'Reselect',
      flightLabel: 'Flight:',
      airportLabel: 'Airport:',
      timeLabel: 'Time:',
      transferLabel: 'Transfer:',
      cabinLabel: 'Cabin:',
      transferInfo: 'Transfer details',
      transferWait: 'Layover:',
      airportWord: 'Airport',
      viewAll: 'View all',
      transferCount: '{count} transfer(s)',
      transferCountTimes: '{count}x',
      transferNth: 'Transfer {n}',
      shareBadge: 'Codeshare',
      taxIncluded: 'Incl. tax',
      layover: 'Layover {duration}',
      stopoverDetail: 'Stopover: {detail}',
      timeoutRetry: 'Search timed out — please retry',
      emptyFiltered: 'No matching flights. Try adjusting filters.',
      reload: 'Reload',
      price: 'Price',
      time: 'Time',
      flightType: 'Flight type',
      directFlight: 'Nonstop',
      transferOnce: '1 transfer',
      transferTwiceOrMore: '2+ transfers',
      filterDep: 'Dep: {name}',
      filterArr: 'Arr: {name}',
      dateSelectTitle: '{journey} date',
      shareTitle: 'Intl flights · Global deals',
      toast: {
        timeoutRetryLater: 'Search timed out — please try again later',
        fetchFail: 'Failed to load flights',
        retrying: 'Request timed out — retry {count}…',
        filterError: 'An error occurred while filtering',
        journeyParseFail: 'Failed to parse itinerary',
      },
    },

    intlChangeList: {
      flightCount: 'Flights',
      passengerCount: 'Passengers',
      searchPlaceholder: 'Search flight no. / city',
      noFlights: 'No flight information',
      passengerList: 'Passengers',
      segmentList: 'Segments',
      unknownCity: 'Unknown city',
      unknownAirline: 'Unknown airline',
      unknownCabin: 'Unknown cabin',
      transferCity: 'Transfer city: {city}',
      layoverTime: 'Layover: {duration}',
      shareFlight: 'Codeshare',
      stopoverDetail: 'Stopover: {detail}',
      layoverMinutes: '{minutes} min layover',
      dataFormatError: 'Unexpected data format',
      fetchFailed: 'Failed to load data',
    },

    intlRefundDetail: {
      segmentInfo: 'Refund segments',
      changeOrderTag: 'Change order',
      noPassengerSegments: 'No refund segments for this passenger',
      noSegments: 'No refund segment info',
      refundAmount: 'Refund amount',
      totalPrice: 'Total fare',
      otherFee: 'Other fees',
      refundFee: 'Refund fee',
      refundServiceFee: 'Refund service fee',
      couponDeduction: 'Coupon deduction',
      unionPointRefund: 'Points to refund',
      unionPointCount: '{count} pts',
      actualRefund: 'Actual refund',
      pendingReview: 'Under review',
      usedCoupons: 'Coupons used',
      ticketNo: 'Ticket No.: {no}',
      refundNote: 'Refund notes',
      note1: '1. After confirming, the refund request cannot be cancelled',
      note2: '2. After confirming, refunds follow airline rules',
      note3:
        '3. After a successful refund, insurance on covered segments will be refunded separately — see insurance cancellation records; amounts on this page exclude insurance',
      note4: '4. Refunds return to the original payment method within 3–7 business days',
      refundChangeRules: 'Change & refund rules',
      refundRulesTitle: '{type} refund rules',
      changeRulesTitle: '{type} change rules',
      afterTakeoff: 'After departure',
      beforeTakeoff: 'Before departure',
      emptyRules: 'Subject to airline policy',
      cancelRefund: 'Cancel refund',
      confirmRefund: 'Confirm refund',
      back: 'Back',
      free: 'Free',
      notAllowed: 'Non-refundable / non-changeable',
      rejectedFallback: 'Refund request rejected',
      status: {
        '0': 'Under review',
        '1': 'Pending confirm',
        '2': 'Rejected',
        '3': 'Refunding',
        '4': 'Refunded',
        '5': 'Cancelled',
        unknown: 'Unknown',
      },
      statusDesc: {
        '0': 'Please wait for review',
        '1': 'Please confirm the refund amount',
        '2': 'Refund request rejected',
        '3': 'Refund in progress — please wait',
        '4': 'Refund completed — thank you',
        '5': 'Refund request cancelled',
      },
      passengerType: {
        adult: 'Adult',
        child: 'Child',
        infant: 'Infant',
      },
      idType: {
        '1': 'ID card',
        '2': 'Passport',
        '3': 'Military ID',
        '4': 'Seafarer ID',
        '5': 'HK/Macao permit',
        '6': 'Taiwan permit',
        '7': 'Taiwan compatriot permit',
        '8': 'Home return permit',
        '9': 'Student',
        '10': 'Foreign residence permit',
        '11': 'Other',
        fallback: 'ID',
      },
      toast: {
        dataIncomplete: 'Incomplete refund data',
        loadFail: 'Failed to load refund details',
        loadFailRetry: 'Failed to load refund details — please try again',
        cancelSuccess: 'Refund request cancelled',
        cancelFail: 'Failed to cancel refund',
        cancelFailRetry: 'Failed to cancel refund — please try again',
        confirmSuccess: 'Refund request confirmed',
        confirmFail: 'Failed to confirm refund',
        confirmFailRetry: 'Failed to confirm refund — please try again',
      },
      dialog: {
        cancelTitle: 'Cancel refund',
        cancelMsg: 'Cancel this refund request?',
        confirmTitle: 'Confirm refund',
        confirmMsg:
          'This cannot be undone. Refunds arrive in 3–7 business days. Confirm?',
      },
    },

    intlChangeDetail: {
      payRemainTime: 'Time left to pay: ',
      changeOrderNo: 'Change order No.: ',
      copy: 'Copy',
      submitTime: 'Submitted: ',
      flightInfo: 'Flight info',
      passengerFallback: 'P',
      originalFlight: 'Original',
      newFlight: 'New flight',
      ticketNo: 'Ticket No.: ',
      changeInfo: 'Change info',
      changeType: 'Change type: ',
      changeNature: 'Change nature: ',
      voluntary: 'Voluntary',
      involuntary: 'Involuntary',
      changeReason: 'Reason: ',
      rejectReason: 'Rejection reason: ',
      priceDetail: 'Price details',
      ticketDiff: 'Fare difference: ',
      changeFee: 'Change fee: ',
      otherFee: 'Other fees: ',
      insuranceFee: 'Insurance: ',
      subtotal: 'Subtotal: ',
      total: 'Total: ',
      pendingReview: 'Under review',
      changeInsurance: 'Change insurance',
      changeInsuranceService: 'Change insurance service',
      viewDetail: 'View details',
      refundChangeRules: 'Change & refund rules',
      changeRulesTab: 'Change rules',
      refundRulesTab: 'Refund rules',
      emptyChangeRules: 'No change rules available. Subject to airline policy.',
      emptyRefundRules: 'No refund rules available. Subject to airline policy.',
      contactInfo: 'Contact',
      nameLabel: 'Name: ',
      mobileLabel: 'Mobile: ',
      emailLabel: 'Email: ',
      cancelChange: 'Cancel change',
      payNow: 'Pay now',
      status: {
        '0': 'Under review',
        '1': 'Pending payment',
        '2': 'Rejected',
        '3': 'Issuing',
        '4': 'Changed',
        '5': 'Cancelled',
        unknown: 'Unknown',
      },
      statusDesc: {
        '0': 'Your change request is awaiting review',
        '1': 'Please complete payment within the time limit',
        '2': 'Your change request was rejected',
        '3': 'Paid — change is being processed',
        '4': 'Change completed',
        '5': 'Change request cancelled',
      },
      passengerType: {
        adult: 'Adult',
        child: 'Child',
        infant: 'Infant',
      },
      changeTypeMap: {
        '1': 'Date change',
        '2': 'Upgrade cabin',
        '3': 'Rebook',
        unknown: 'Unknown type',
      },
      toast: {
        paramError: 'Invalid parameters',
        loadFail: 'Failed to load change details',
        orderNoMissing: 'Order number missing',
        copySuccess: 'Copied',
        cancelSuccess: 'Change cancelled',
        cancelFail: 'Failed to cancel change',
        cancelFailRetry: 'Failed to cancel change — please try again',
      },
      dialog: {
        cancelTitle: 'Cancel this change?',
        cancelMsg: 'The change request will not be kept after cancellation',
      },
    },

    intlChange: {
      stepSelectPassenger: 'Select passenger & segment',
      stepSelectFlight: 'Select change flight',
      stepSubmit: 'Submit application',
      stepBarSelectPassenger: 'Passengers',
      stepBarSelectFlight: 'New flight',
      stepBarSubmit: 'Submit',
      flowTitle: 'Change process',
      flow1: 'Select passengers and segments to change',
      flow2: 'Search available flights for the selected segments',
      flow3: 'Select a flight and submit the change request',
      flow3Desc: 'A change order number and status will be returned',
      flow4: 'Wait for approval to see the exact change fees',
      flow5: 'Confirm and pay the change order, or cancel it',
      flow6: 'After payment the order becomes changing and cannot be cancelled',
      changeType: 'Change type',
      voluntary: 'Voluntary',
      involuntary: 'Involuntary',
      voluntaryDesc: 'Passenger-initiated change',
      involuntaryDesc: 'Airline-initiated change',
      normalOrder: 'Original order',
      changeOrder: 'Change order',
      selectPassengerSegment: 'Select passengers & segments',
      selectChangeOrder: 'Select change order',
      selectSegment: 'Select segments',
      segmentTip:
        'Each passenger may only select segments from the same journey; all passengers must select the same segments and have all selected segments.',
      departed: 'Departed',
      changeOrderTitle: 'Change order #{n}',
      passengerPrefix: 'Passengers: ',
      changeReason: 'Change reason',
      changeReasonPlaceholder: 'Enter change reason',
      changeDate: 'Change date',
      changeDatePlaceholder: 'Select change date (default today)',
      changeCabin: 'Cabin class',
      cabinTip: 'Change is limited to same-flight date change or upgrade; downgrade is not allowed',
      cabin: {
        economy: 'Economy',
        premiumEconomy: 'Premium economy',
        business: 'Business',
        first: 'First',
        unknown: 'Unknown cabin',
      },
      backPrevPage: 'Back',
      nextStep: 'Next',
      prevStep: 'Previous',
      searching: 'Searching...',
      noChangeFlights: 'No changeable flights',
      backModify: 'Go back and edit',
      transferTimes: '{count} transfer(s)',
      totalDuration: 'Total {duration}',
      waitTime: 'Layover {duration}',
      taxInclusive: 'Incl. tax',
      refundChange: 'Rules',
      passengerOriginFlight: 'Passengers & original flight',
      newFlightInfo: 'New flight',
      cabinTypeLabel: 'Cabin:',
      priceLabel: 'Price:',
      directFlight: 'Nonstop',
      submitApply: 'Submit',
      refundChangeRules: 'Change & refund rules',
      changeRules: 'Change rules',
      refundRules: 'Refund rules',
      timePeriod: 'Period',
      fee: 'Fee',
      followAirline: 'Subject to airline policy',
      baggageAllowance: 'Baggage',
      segmentLabel: 'Segment: {cities}',
      checkedBaggage: 'Checked: {count} pc(s) {weight}{unit}',
      carryOn: 'Carry-on: {count} pc(s) {weight}{unit}',
      tipTitle: 'Notes',
      tip1: '1. Rules follow airline policy; contact support if unsure',
      tip2: '2. Delays/cancellations may qualify for involuntary policy',
      tip3: '3. Change/refund may incur fees',
      confirm: 'OK',
      submitting: 'Submitting...',
      loading: 'Loading...',
      free: 'Free',
      notAllowed: 'Not allowed',
      yuan: '¥{amount}',
      hoursMinutes: '{hours}h {minutes}m',
      hoursMinutesSeconds: '{hours}h {minutes}m {seconds}s',
      afterTakeoff: 'After departure',
      beforeTakeoffAfterInclusive: 'Within {hours}h before departure (incl.)',
      beforeTakeoffAfter: 'Within {hours}h before departure',
      beforeTakeoffBeforeInclusive: 'More than {hours}h before departure (incl.)',
      beforeTakeoffBefore: 'More than {hours}h before departure',
      andAfter: 'and after',
      after: 'after',
      andBefore: 'and before',
      before: 'before',
      journeyN: 'Journey {n}',
      journeySegment: 'Journey {journey} · Segment {segment}',
      journeySegmentFallback: 'Journey · Segment',
      noPassengerInfo: 'No passengers',
      passengersMore: '{name1}, {name2} +{count}',
      passengerNameSep: ', ',
      unknown: 'Unknown',
      passengerFallback: 'Passenger',
      changeTypeMap: {
        '1': 'Date change',
        '2': 'Upgrade cabin',
        '3': 'Rebook',
        unknown: 'Unknown type',
      },
      toast: {
        loadOrderFail: 'Failed to load order details',
        loadOrderFailRetry: 'Failed to load order details — please retry',
        selectPassengerError: 'Failed to select passenger',
        childAlone: 'Child cannot change alone — select an adult first',
        noChangeableSegments: 'No changeable segments for this passenger',
        missingSegments: 'Passenger is missing some selected segments',
        selectPassengerErrorRetry: 'Failed to select passenger — please retry',
        segmentDeparted: 'Segment has departed and cannot be selected',
        passengerNotFound: 'Passenger not found',
        segmentStatusNotAllowed: 'Segment status does not allow change',
        segmentChanging: 'Segment is already being changed',
        sameJourneyOnly: 'A passenger may only select segments from the same journey',
        currentMissingSegments: 'Current passenger is missing some selected segments',
        sameSegmentsOnly: 'Must select the same segments as other passengers',
        selectSegmentErrorRetry: 'Failed to select segment — please retry',
        noDowngrade: 'Cabin downgrade is not allowed — choose same or higher class',
        querySuccess: 'Search succeeded',
        noFlightsModify: 'No changeable flights — adjust search criteria',
        queryFail: 'Failed to search changeable flights',
        queryFailRetry: 'Failed to search changeable flights — please retry',
        operateFail: 'Operation failed — please retry',
        invalidChangeOrder: 'Invalid change order selected',
        selectChangeFlight: 'Please select a change flight',
        submitSuccess: 'Change request submitted',
        submitFail: 'Failed to submit change request',
        submitFailRetry: 'Failed to submit change request — please retry',
        changeTypeError: 'Failed to determine change type',
        noOriginFlight: 'Unable to get original flight info',
        selectChangeOrder: 'Please select a change order',
        noNewFlight: 'Unable to get new flight info',
        selectFlight: 'Please select a flight',
        noChangeablePassenger: 'No changeable passengers',
        noSelectablePassenger: 'No selectable passengers on this change order',
        selectPassengerFirst: 'Please select passengers first',
        orderParamError: 'Invalid order parameters',
        selectPassenger: 'Please select passengers',
        selectSegment: 'Please select segments',
        segmentsMismatch:
          '{name}: segments differ from other passengers — all must select the same segments',
        inputChangeReason: 'Please enter a change reason',
        dateFormatReset: 'Invalid date format — reset to today',
        selectCabin: 'Please select a cabin class',
        dateEarlierThanPrev: 'Change date is earlier than previous leg arrival — pick a later date',
        dateLaterThanNext: 'Change date is later than next leg departure — pick an earlier date',
      },
    },

    intlRefund: {
      loading: 'Loading...',
      flowTitle: 'Refund process',
      readCarefully: 'Please read carefully',
      flow1: 'Select refund segments for each passenger (multiple allowed)',
      flow2: 'Enter the refund reason',
      flow3: 'Submit the refund request for review',
      rulesTitle: 'Refund rules',
      ruleBeforeDepartHighlight: 'Before departure: ',
      ruleBeforeDepart: 'All unused segments must be refunded together',
      ruleAfterDepartHighlight: 'After departure: ',
      ruleAfterDepart: 'Unused segments can be refunded in sequence',
      statusPartialDeparted: 'Status: Some segments have departed',
      statusAllNotDeparted: 'Status: No segments have departed',
      refundType: 'Refund type',
      voluntary: 'Voluntary refund',
      involuntary: 'Involuntary refund',
      voluntaryDesc: 'Passenger-initiated refund',
      involuntaryDesc: 'Airline-initiated refund',
      proofFiles: 'Supporting documents',
      normalOrder: 'Original order',
      changeOrder: 'Change order',
      selectChangeOrder: 'Select the change order to refund',
      noChangeOrders: 'No refundable change orders',
      selectPassengerSegment: 'Select passenger segments',
      selectChangePassengerSegment: 'Select change-order passenger segments',
      multiSegmentTip: 'Selecting a segment also selects all subsequent segments',
      departed: 'Departed',
      dependentSelected: 'Auto-selected',
      journeySegment: '{journey}-Seg {segment}',
      journeyN: 'Journey {n}',
      refundReason: 'Refund reason',
      reasonType: 'Reason type',
      reasonTypePickerTitle: 'Select reason type',
      reasonTypePlaceholder: 'Select reason type',
      reasonDesc: 'Reason details',
      reasonDescPlaceholder: 'Describe the refund reason in detail',
      submitting: 'Submitting...',
      noRefundablePassenger: 'No refundable passengers',
      selectSegment: 'Select segments for passengers',
      submitApply: 'Submit refund',
      sequenceTitle: 'Refund sequence tip',
      sequenceSuggest: 'Suggested order:',
      currentSelect: 'Current selection: ',
      sequenceWarning:
        'This selection may invalidate earlier segment refunds. Please refund in segment order.',
      adjustSequence: 'Adjust order',
      continueAnyway: 'Continue anyway',
      reasonOptions: {
        '0': 'Itinerary changed — cannot travel',
        '1': 'Flight delay',
        '2': 'Flight diversion',
        '3': 'Flight cancellation',
        '4': 'Medical (health reasons)',
        '5': 'Duplicate booking',
        '6': 'Other',
      },
      toast: {
        noRefundableContent: 'Nothing refundable on this order',
        loadOrderFail: 'Failed to load order',
        loadOrderFailRetry: 'Failed to load order — please try again',
        segmentDeparted: 'This segment has departed and cannot be selected',
        dependentSegment: 'This segment was auto-selected — deselect the earlier segment first',
        mustRefundAll:
          'Before departure all segments must be refunded together — selecting all segments for you',
        noRefundablePassenger: 'No refundable passengers',
        noRefundableChangeOrder: 'No refundable change orders',
        changeOrderNoPassenger: 'No refundable passengers on this change order',
        selectSegment: 'Select segments for passengers',
        selectReasonType: 'Select a reason type',
        inputReasonDesc: 'Enter the refund reason details',
        noTicketNo: 'No refundable ticket number found',
        submitSuccess: 'Refund submitted — redirecting...',
        submitFailRetry: 'Failed to submit refund — please try again',
        orderIncomplete: 'Incomplete order information',
      },
    },

    intlProgress: {
      travelReminder: 'Travel tips',
      travelReminderColon: 'Travel tips:',
      fraudReminder: 'Fraud alert',
      passengerSegmentInfo: 'Passengers & segments',
      refundPrefix: 'Refund ¥',
      refundDetail: 'Refund details',
      updateDate: 'Updated: {date}',
      fraudBodyPrefix:
        'Calls claiming flight cancellation or mechanical issues asking you to call back, download apps, or wire money for changes ',
      mayBeFraud: 'may be a scam',
      fraudBodySuffix:
        '. Check your order details or the airline website. Contact support or the airline to verify.',
      referenceNote: '*For reference only',
      gotIt: 'Got it',
      totalPrice: 'Total fare',
      refundableTicketAmount: 'Refundable ticket amount',
      deductions: 'Deductions',
      refundFee: 'Refund fee',
      otherFee: 'Other fees',
      refundServiceFee: 'Refund service fee',
      couponDeduction: 'Coupon deduction',
      actualRefund: 'Actual refund',
      ticketRefunded: 'Refunded',
      ticketIssued: 'Issued',
      unknown: 'Unknown',
      toast: {
        loadProgressFail: 'Failed to load refund progress',
        loadProgressFailRetry: 'Failed to load refund progress — please try again',
        loadOrderFail: 'Failed to load order details',
        loadOrderFailRetry: 'Failed to load order details — please try again',
        orderParamError: 'Invalid order parameters',
      },
    },

    toast: {
      uncollectSuccess: 'Removed from favorites',
      collectSuccess: 'Added to favorites',
      selectChangePassenger: 'Select passenger(s) to change',
      childAloneChange: 'Children cannot change alone',
      remainingChildAlone: 'Remaining child cannot change alone',
      remainingChildrenNoAdult: 'Remaining children need an adult',
      sameChangeTime: 'New time cannot match original departure',
      noChangeFlightsToday: 'No changeable flights today',
      selectPassenger: 'Select passenger(s)',
      childNeedsAdult: 'Child needs adult companion',
      invalidPhone: 'Enter a valid phone number',
      agreeTreaty: 'Please accept terms',
      selectPayMethod: 'Select a payment method',
      paymentMethodsLoading: 'Payment methods are loading, please wait',
      priceExpired: 'Fare expired — search again',
      selectPassengerFirst: 'Select passenger(s) first',
      couponSelected: 'Coupon applied: -¥{amount}',
      couponCancelled: 'Coupon removed',
      couponSelectFailed: 'Failed to apply coupon',
      couponCalcFailed: 'Failed to calculate discount',
      couponLoadFailed: 'Failed to load coupons',
      addCartSuccess: 'Added to cart',
      addCartFailed: 'Failed to add to cart. Please try again',
      flightCartInvalid: 'Flight information expired. Search again',
      selectCartProduct: 'Select a product',
      networkError: 'Network error — try again',
      airlineListFailed: 'Failed to load airlines',
      intlChildLimit: 'Intl: max 1 child/infant per adult',
      sameCity: 'Departure and destination must differ',
      completeLeg: 'Complete leg {n} cities',
      legSameCity: 'Leg {n} cities must differ',
      multiNeedIntlLeg: 'Multi-city (non round-trip) requires at least one international city',
      intlMainlandBoth: 'Cannot be two mainland China cities',
      domesticChildLimit: 'Max 1 child/infant per adult',
      invalidId: 'Invalid ID number',
      invalidIdCard: 'Invalid ID card number',
      fillRequired: 'Fill required fields',
      selectExpiry: 'Select ID expiry',
      policyholderAge: 'Policyholder must be over 18',
      invalidMobile: 'Invalid mobile number',
      intlNationalityBirthday: 'Nationality and DOB required (intl)',
      fillSurname: 'Enter surname',
      invalidEmail: 'Invalid email',
      nationalityLoadFailed: 'Failed to load nationalities',
      maxMultiSelect: 'Select up to 3',
      alreadySelected: 'Already selected',
      loadCityFailed: 'Failed to load cities',
      loadContinentFailed: 'Failed to load continents',
      loadCountryFailed: 'Failed to load countries',
      searchFailed: 'Search failed',
      loadAirportFailed: 'Failed to load airports',
      noAirportInfo: 'No airports for this city — selecting the city instead',
      idVerifyFailed: 'ID verification failed',
      saveSuccess: 'Added successfully!',
      editSuccess: 'Updated successfully!',
      saveFailed: 'Save failed',
      saveFailedRetry: 'Save failed — please try again',
      loadPassengerFailed: 'Failed to load passenger — please try again',
      loadPolicyholderFailed: 'Failed to load policyholder — please try again',
      initFailed: 'Initialization failed — please try again',
      adLoadFailed: 'Failed to load ads',
      requestTimeout: 'Request timed out — please try again later',
    },
  },
}
